import component from './addressFinder.component';
import service from './addressFinder.service';

export default angular.module('mpdx.common.addressFinder', [component, service]).name;
